import { Skeleton } from '@mui/material'
import { Container, Gap, SectionSkeleton, VerticalRule } from '../../../../schedule/Schedule/Layout'

const Loading = () => (
  <Container>
    <SectionSkeleton gridArea="configuration" />
    <VerticalRule />
    <SectionSkeleton gridArea="day" />
    <VerticalRule />
    <SectionSkeleton gridArea="time" />
    <Gap style={{ gridArea: 'gap' }} />
    <Skeleton variant="rectangular" width="100%" height="3rem" style={{ gridArea: 'ctas' }} />
  </Container>
)

export { Loading }
